import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LIMIT_PER_PAGE } from "../../helpers/constant";
import { IOtherUserFeed } from "../../helpers/types";
import { getOtherUserFeedsById, getUserFeeds } from "../../redux/feeds/feedsSlice";
import { AppDispatch, StoreState } from "../../redux/store";

const useFetchFeeds = (id: string | null, isCurrentUser: boolean) => {
  const dispatch = useDispatch<AppDispatch>();
  const { currentFeeds, otherUserFeeds, loading, error } = useSelector((state: StoreState) => state.feeds);
  const [feeds, setFeeds] = useState<IOtherUserFeed | null>(null);

  const fetchOtherUserFeeds = useCallback(
    (creatorId: string) => {
      if (otherUserFeeds.length === 0) {
        dispatch(getOtherUserFeedsById({ creatorId, offset: 0, limit: LIMIT_PER_PAGE }));
      } else {
        const feeds = otherUserFeeds.find((user: IOtherUserFeed) => user.id === id);
        if (feeds) {
          setFeeds(feeds);
        } else {
          dispatch(getOtherUserFeedsById({ creatorId, offset: 0, limit: LIMIT_PER_PAGE }));
        }
      }
    },
    [dispatch, otherUserFeeds, id]
  );

  const fetchCurrentUserFeeds = useCallback(() => {
    currentFeeds ? setFeeds(currentFeeds) : dispatch(getUserFeeds());
  }, [dispatch, currentFeeds]);

  useEffect(() => {
    if (!isCurrentUser && id) {
      fetchOtherUserFeeds(id);
    }
    if (isCurrentUser) {
      fetchCurrentUserFeeds();
    }
  }, [id, isCurrentUser, fetchOtherUserFeeds, fetchCurrentUserFeeds]);

  return { loading, error, feeds };
};

export default useFetchFeeds;
